import { IconType } from "./icons.types";

const DownwardIcon = ({ className, color = "#0C8CE9" }: IconType) => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.3166 27.3586C19.3166 27.2002 19.3749 27.0419 19.4999 26.9169C19.7416 26.6752 20.1416 26.6752 20.3832 26.9169L24.9999 31.5336L29.6166 26.9169C29.8582 26.6752 30.2582 26.6752 30.4999 26.9169C30.7416 27.1586 30.7416 27.5586 30.4999 27.8002L25.4416 32.8586C25.1999 33.1002 24.7999 33.1002 24.5582 32.8586L19.4999 27.8002C19.3749 27.6752 19.3166 27.5169 19.3166 27.3586Z"
        fill={color}
      />
      <path
        d="M24.3749 32.2752V18.2502C24.3749 17.9086 24.6582 17.6252 24.9999 17.6252C25.3416 17.6252 25.6249 17.9086 25.6249 18.2502V32.2752C25.6249 32.6169 25.3416 32.9002 24.9999 32.9002C24.6582 32.9002 24.3749 32.6169 24.3749 32.2752Z"
        fill={color}
      />
    </svg>
  );
};

export default DownwardIcon;
